<header class="header fixed-header" [ngClass]="{ 'sticky': scrolled }">
  <div class="header__logo">
    <figure>
      <a routerLink="/home">
        <img src="assets/img/CHUBB_Logo_Red_digital.png" width="150px" alt="Chubb">
      </a>
    </figure>
    <aside class="header__button">
      <fa-icon class="desktop" [icon]="bars" (click)="hideSideBar()" size="2x"></fa-icon>
      <fa-icon class="mobile" [icon]="bars" (click)="hideSideBar()" size="2x"></fa-icon>
    </aside>
  </div>

  <div class="header__user">
    <div class="btn-group" dropdown>
      <button id="button-custom-html" dropdownToggle type="button" class="btn btn-transparent nobounds"
        aria-controls="dropdown-custom-html">
        <fa-icon [icon]="user" size="2x"></fa-icon>
        <i icon="user" size="2x"></i>
        {{userName}}<span class="caret"></span>
      </button>
      <ul id="dropdown-custom-html" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
        aria-labelledby="button-custom-html">
        <li role="menuitem">
          <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">
            <i class="fa-solid fa-right-from-bracket"></i>
            Cerrar Sesión
          </a>
        </li>
      </ul>
    </div>
  </div>
</header>